// extracted by mini-css-extract-plugin
module.exports = {"container":"StoreProfitsList_container__16Lwx","buttonsContainer":"StoreProfitsList_buttonsContainer__2y8M5","button":"StoreProfitsList_button__2Pdrv"};